export const DiagonalArrow = () => (
  <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M1.48841 9.24772L8.27241 2.46372L8.67241 8.35172L9.55241 7.47172L9.16841 0.879719L2.57641 0.511719L1.69641 1.39172L7.60041 1.79172L0.816406 8.57572L1.48841 9.24772Z"
      fill="#858DBD"
    />
  </svg>
);
